export default {
  title: 'Members',
};
